<template>
  <div class="bg-tonedBackground fill-height d-flex flex-column">
    <the-skeleton-anonymous
      v-if="!isLoggedIn"
      class="flex-grow-0 d-print-none"
    />
    <the-skeleton-logged-in v-else class="flex-grow-0 d-print-none" />
    <v-main class="flex-grow-1">
      <slot name="default" />
    </v-main>
  </div>
</template>

<script lang="ts" setup>
import useLoginData from '@/common/composition/useLoginData';
import TheSkeletonLoggedIn from './TheSkeletonLoggedIn.vue';
import TheSkeletonAnonymous from './TheSkeletonAnonymous.vue';

const { isLoggedIn } = useLoginData();
</script>
